/**
 * The mission HUD (M7 plan S35, order `FEATURE_ORDER.storyHud` 537: after the wing HUD 535, before station services
 * 540 and comms 545). Runs only in the Reach with the story service (`story`, the storyLink feature at 173). The
 * runtime (`live.ts`: the objective line, the story markers, the Leads map layer) loads lazily with the story data.
 */
import { FEATURE_ORDER, type FrameInfo, type GameContext, type GameFeature } from '../../app/feature'
import { logger } from '../../core/logger'
import type { StoryHudRuntime } from './live'

let runtime: StoryHudRuntime | null = null

const feature: GameFeature = {
  name: 'storyHud',
  order: FEATURE_ORDER.storyHud,
  async init(ctx: GameContext): Promise<void> {
    const reach = ctx.reach
    const story = ctx.services.maybe('story')
    const m2 = ctx.services.maybe('m2')
    if (reach === null || story === undefined || m2 === undefined) return
    const client = ctx.services.maybe('strategic')
    try {
      const { createStoryHudRuntime } = await import('./live')
      runtime = createStoryHudRuntime(ctx, {
        reach,
        story,
        career: () => m2.career(),
        ...(client === undefined ? {} : { storyView: () => client.storyView() }),
      })
    } catch (err: unknown) {
      logger.warn('story HUD: did not start', err)
    }
  },
  frame(ctx: GameContext, f: FrameInfo): void {
    runtime?.frame(ctx, f)
  },
  dispose(): void {
    runtime?.dispose()
    runtime = null
  },
}

export default feature
